import { createClient } from '@supabase/supabase-js';
import { assertFrontendBackendConfig } from "@/lib/frontend-backend-config";

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL as string | undefined;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY as string | undefined;

if (import.meta.env.PROD) {
  assertFrontendBackendConfig({
    url: supabaseUrl,
    anonKey: supabaseAnonKey,
    allowE2EBackend: import.meta.env.VITE_TRADIVO_ALLOW_E2E_BACKEND === "1",
  });
}

export const supabase = createClient(supabaseUrl ?? "", supabaseAnonKey ?? "", {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});

export default supabase;